import isLikeTrue from './isLikeTrue';
import isLikeFalse from './isLikeFalse';

export function convertToNullOrValidBoolean(
  value: string | null,
): boolean | null {
  if (isLikeTrue(value)) {
    return true;
  } else if (isLikeFalse(value)) {
    return false;
  } else {
    return null;
  }
}
